// Types
import type { WindLine } from './types';

// Constants
import { ANIMATION_CONFIG } from './constants';

/**
 * Calculate vertical bounce offset
 */
export const getBounceY = (frame: number, progress: number): number => {
  if (progress < ANIMATION_CONFIG.BOUNCE_START_THRESHOLD) return 0;

  const framesSinceArrival = frame - ANIMATION_CONFIG.ARRIVAL_DURATION_FRAMES;
  return (
    Math.sin(framesSinceArrival * ANIMATION_CONFIG.BOUNCE_SPEED) *
    ANIMATION_CONFIG.BOUNCE_AMPLITUDE_PX
  );
};

/**
 * Calculate scale zoom multiplier
 */
export const getZoomScale = (frame: number, progress: number): number => {
  if (progress < ANIMATION_CONFIG.BOUNCE_START_THRESHOLD) return 1;

  const framesSinceArrival = frame - ANIMATION_CONFIG.ARRIVAL_DURATION_FRAMES;
  return (
    1 +
    Math.sin(framesSinceArrival * ANIMATION_CONFIG.ZOOM_SPEED) *
      ANIMATION_CONFIG.ZOOM_AMPLITUDE
  );
};

/**
 * Build SMIL dasharray values
 */
export const getDashArray = (line: WindLine): string => {
  const { dashValues, dashArray } = line;
  return `${dashValues[0]} ${dashArray}; ${dashValues[1]} ${dashArray - dashValues[1]}; ${dashValues[2]} ${dashArray}`;
};

/**
 * Build SMIL dashoffset values
 */
export const getDashOffset = (line: WindLine): string =>
  line.dashOffset.join('; ');
